if (!customElements.get('alphabet-index')) {
  class AlphabetIndex extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;

      event.preventDefault();

      // The sticky header only shows while scrolling up, so only reserve
      // space for it when the jump goes upwards.
      const targetTop = target.getBoundingClientRect().top;
      let offset = 16;
      if (targetTop < 0) {
        const headerHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        );
        if (!Number.isNaN(headerHeight)) offset += headerHeight;
      }

      window.scrollTo({
        top: window.scrollY + targetTop - offset,
        behavior: 'smooth'
      });
      history.replaceState(null, '', link.getAttribute('href'));
    }
  }

  customElements.define('alphabet-index', AlphabetIndex);
}
